import switchEstimate from '../Services/switchEstimate';

export default (estimate: Object) => async (dispatch) => {

  const { id } = estimate;

  dispatch(switchEstimate(id));
  
}